<template>
  <div class="user-profile-drop-downn">
    <b-dropdown
      right
      no-caret
      size="lg"
      variant="sm"
      class="d-none d-lg-block"
      menu-class="resize-dropdown"
      toggle-class="text-decoration-none"
    >
      <template #button-content>
        <div class="btn avatar-perfil px-0">
          <div class="avatar-border">
            <img
              class="mr-3"
              src="@/assets/images/avatar-placeholder.png"
              alt="User picture"
            />
          </div>
          <span class="limit-user-name">{{
            $user.user ? $user.user.name : ""
          }}</span>
          <h5 class="p-0 m-0"><i class="icon-angle-down ml-2" /></h5>
        </div>
      </template>
      <drop-down-content @logout="$emit('logout')" @close="close" />
    </b-dropdown>
    <button class="btn avatar-perfil d-lg-none" @click="open">
      <div class="avatar-border">
        <img src="@/assets/images/avatar-placeholder.png" alt="User picture" />
      </div>
    </button>
    <responsive-modal v-model="visible" class="d-lg-none">
      <drop-down-content @logout="$emit('logout')" @close="close" />
    </responsive-modal>
  </div>
</template>
<script>
import vClickOutside from "v-click-outside";
import DropDownContent from "./Content.vue";

export default {
  components: { DropDownContent },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      visible: false,
      dropdownOpened: false
    };
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", bvEvent => {
      this.dropdownOpened = true;
    });
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.user-profile-drop-downn {
  display: flex;
  justify-content: flex-end;
  background: transparent;
  ::v-deep.dropdown-menu.show {
    min-width: 265px !important;
    max-width: 365px !important;
    box-shadow: 0px 4.99685px 14.99054px 0px rgba(0, 0, 0, 0.15),
      0px 16px 32px 12px rgba(0, 0, 0, 0.08);
  }

  .btn.avatar-perfil:active {
    background: rgba(145, 85, 236, 0.1);
    border-radius: 4px;
  }

  .limit-user-name {
    max-width: 200px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .avatar-border {
    outline: 1px solid #8323ff;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin: 8px;
  }
}
</style>
